var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckmarkLightBlue = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12.5C2.5 6.99219 6.95312 2.5 12.5 2.5C18.0078 2.5 22.5 6.99219 22.5 12.5C22.5 18.0469 18.0078 22.5 12.5 22.5C6.95312 22.5 2.5 18.0469 2.5 12.5ZM16.9922 10.7812C17.4219 10.3516 17.4219 9.6875 16.9922 9.25781C16.5625 8.82812 15.8984 8.82812 15.4688 9.25781L11.25 13.4766L9.49219 11.7578C9.0625 11.3281 8.39844 11.3281 7.96875 11.7578C7.53906 12.1875 7.53906 12.8516 7.96875 13.2812L10.4688 15.7812C10.8984 16.2109 11.5625 16.2109 11.9922 15.7812L16.9922 10.7812Z",
    fill: "#7CC9D1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmarkLightBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkmark-light-blue.0cf2e9047353177717e1bfc34bfe2e0a.svg";